
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sifted-for-angels",
      function () {
        return require("private-next-pages/sifted-for-angels/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sifted-for-angels"])
      });
    }
  